import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { restApi } from '../../../services/Api'

const anexosRepository = createRepository({
  parentPath: 'bloqueio-manual-kmm',
  path: 'anexos',
  relationType: 'path',
  restApi
})

anexosRepository.uploadAnexos = (bloqueioManualKmmId, data, file) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('data', JSON.stringify(data))
  return restApi.post(
    `bloqueio-manual-kmm/${bloqueioManualKmmId}/anexos`,
    formData,
    {
      header: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

export default anexosRepository
